import { Paper, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import { getMenusFromToken } from "../../utils/auth";

import {
  DashboardOutlined as DashboardOutlinedIcon,
  AssessmentOutlined as AssessmentOutlinedIcon,
  CableOutlined as CableOutlinedIcon,
  LocalGasStationOutlined as LocalGasStationOutlinedIcon,
  ReceiptLongOutlined as ReceiptLongOutlinedIcon,
  PeopleAltOutlined as PeopleAltOutlinedIcon,
  SecurityOutlined as SecurityOutlinedIcon,
  NotificationsActiveOutlined as NotificationsActiveOutlinedIcon,
  LocalFireDepartmentOutlined as LocalFireDepartmentOutlinedIcon,
  AccessTimeOutlined as AccessTimeOutlinedIcon, // 👈 Employee Shift icon
} from "@mui/icons-material";

const menuRoutes = {
  Dashboard: "/dashboard",
  Reports: "/reports",
  "Pump Port": "/pump-port",
  Pump: "/pump",
  "Pump Transaction": "/pump-transaction",
  "User Management": "/user-management",
  "Role Management": "/role-management",
  Alert: "/alert",
  Fuel: "/fuel",
  "Employee Shift": "/employee-shift",
};

const menuIcons = {
  Dashboard: <DashboardOutlinedIcon sx={{ fontSize: 50, color: "#1565c0" }} />,
  Reports: <AssessmentOutlinedIcon sx={{ fontSize: 50, color: "#1565c0" }} />,
  "Pump Port": <CableOutlinedIcon sx={{ fontSize: 50, color: "#1565c0" }} />,
  Pump: <LocalGasStationOutlinedIcon sx={{ fontSize: 50, color: "#1565c0" }} />,
  "Pump Transaction": (
    <ReceiptLongOutlinedIcon sx={{ fontSize: 50, color: "#1565c0" }} />
  ),
  "User Management": (
    <PeopleAltOutlinedIcon sx={{ fontSize: 50, color: "#1565c0" }} />
  ),
  "Role Management": (
    <SecurityOutlinedIcon sx={{ fontSize: 50, color: "#1565c0" }} />
  ),
  Alert: (
    <NotificationsActiveOutlinedIcon sx={{ fontSize: 50, color: "#1565c0" }} />
  ),
  Fuel: (
    <LocalFireDepartmentOutlinedIcon sx={{ fontSize: 50, color: "#1565c0" }} />
  ),
  "Employee Shift": (
    <AccessTimeOutlinedIcon sx={{ fontSize: 50, color: "#1565c0" }} />
  ),
};

export default function Dashboard() {
  const navigate = useNavigate();
  const menus = getMenusFromToken();

  return (
    <Layout title="Dashboard">
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(auto-fill, minmax(160px, 1fr))",
            md: "repeat(auto-fill, minmax(180px, 1fr))",
          },
          gap: { xs: 2, md: 3 },
          alignItems: "stretch",
        }}
      >
        {menus.map((menu) => (
          <Paper
            key={menu}
            elevation={4}
            sx={{
              minHeight: { xs: 120, sm: 145, md: 160 },
              width: "100%",
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 2,
              cursor: "pointer",
              transition: "0.3s",
              p: { xs: 1.5, sm: 2 },
              "&:hover": {
                bgcolor: "#e3f2fd",
                transform: { xs: "none", md: "scale(1.03)" },
              },
            }}
            onClick={() => navigate(menuRoutes[menu])}
          >
            <Box sx={{ mb: 1 }}>{menuIcons[menu]}</Box>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                overflowWrap: "anywhere",
                whiteSpace: "normal",
                px: 1,
                maxWidth: "100%",
              }}
            >
              {menu}
            </Typography>
          </Paper>
        ))}
      </Box>
    </Layout>
  );
}
